import { gql } from '@apollo/client'

export const DELETE_TRACKING_TICKET = gql`
  mutation DeleteTrackingTicketMutation($ticketId: String!) {
    deleteAppointmentTracking(ticketId: $ticketId) {
      success
    }
  }
`
